import React, {useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import Config from '../../../Config';
import {setSelectedHetPayAllowedToActions, setSelectedHetPay} from '../../Block/PortalsBlock/portalSlice';
import ReactSelect from '../ReactSelect/ReactSelect';
import DeniedMessageBox from '../DeniedMessageBox/DeniedMessageBox';
import BtnSubmit from '../Buttons/BtnSubmit';
import EpiContext from '@episerver/spa-core/Spa';

const SelectCompany = (props) => {
  const messageText = `מצטערים אין לך הרשאה לבצע את הפעולה עבור חברה זו`;
  const subMessageText = `חיוג 234* לעדכון ההרשאה`;

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    if (props.portalsBlock.hetPaysNumbers.length === 1 || (props.portalsBlock.selectedHetPay && props.portalsBlock.skipSelectCompanyStep)) {
      validateDefaultCompany();
    }
  }, [props.portalsBlock.hetPaysNumbers]);

  const validateDefaultCompany = () => {
    const selectedCompany = !props.portalsBlock.selectedHetPay
      ? props.portalsBlock.hetPaysNumbers[0].id
      : props.portalsBlock.selectedHetPay;
    validateSelectedOrg(selectedCompany);
  };

  const validateSelectedOrg = (selectedOrgId) => {
    props.setSelectedHetPayAllowedToActions(true);

    if (selectedOrgId) {
      props.setSelectedHetPay(selectedOrgId);
      const selectedOrg = props.portalsBlock.privateCompanyList.find((org) => org.idNumber == selectedOrgId);

      if (!selectedOrg.cellInd || !selectedOrg.allowedCellular) {
        props.setSelectedHetPayAllowedToActions(false);
      } else {
        if (
          props.portalsBlock.hetPaysNumbers.length === 1 ||
          (props.portalsBlock.selectedHetPay && props.portalsBlock.skipSelectCompanyStep)
        ) {
          props.setNextStep(selectedOrg.orgId);
        }
      }
    }
  };

  const goToBusinessLobby = () => {
    EpiContext.navigateTo(Config.businessLobbyUrl);
  };

  const getAction = () => {
    if (!props.portalsBlock.selectedHetPay) {
      return null;
    }
    if (!props.portalsBlock.selectedHetPayAllowedToActions) goToBusinessLobby();
    else props.setNextStep(props.portalsBlock.selectedHetPayId);
  };

  return (
    <div className='select-business-company'>
      <div className='l_title'>{props.title}</div>
      <div>
        <p className='text-right m_title'>עבור איזה ח.פ ברצונך לבקש שירות?</p>
        <ReactSelect
          getOptionLabel={(option) => option.value}
          getOptionValue={(option) => option.key}
          placeholder='בחירת ח.פ.'
          value={props.portalsBlock.selectCompanyOptions.filter((option) => option.key == props.portalsBlock.selectedHetPay)}
          name='selected'
          options={props.portalsBlock.selectCompanyOptions}
          onChange={(e) => validateSelectedOrg(e.key)}
        />
      </div>

      {props.portalsBlock.selectedHetPay && !props.portalsBlock.selectedHetPayAllowedToActions && (
        <DeniedMessageBox text={messageText} subText={subMessageText} asBtn={isMobile ? true : false} tel={window.Config.businessCallNumber} />
      )}

      <div className='continue-button'>
        <BtnSubmit
          text={`${props.portalsBlock.selectedHetPayAllowedToActions ? 'המשך' : 'סיום'}`}
          disabled={!props.portalsBlock.selectedHetPay}
          onclick={() => {
            getAction();
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    portalsBlock: state.portalsBlock,
  };
};

const mapDispatchToProps = {
  setSelectedHetPayAllowedToActions,
  setSelectedHetPay,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectCompany);
